let dirPath = 'static/games/page010_game1';

let configGame = {
  removeInCorrects: false,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: { shuffle: true },
    itemsGarbage: [{ idGroup: 'checks', itemsConfig: { block: false } }],
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      { idGroup: 'checks', idItem: 's00', correct: [{ idGroup: 'checks', idItem: 's00' }] },
      { idGroup: 'checks', idItem: 's01', correct: [{ idGroup: 'checks', idItem: 's01' }] },
      { idGroup: 'checks', idItem: 's02', correct: [{ idGroup: 'checks', idItem: 's02' }] },
      { idGroup: 'checks', idItem: 's03', correct: [{ idGroup: 'checks', idItem: 's03' }] },
      { idGroup: 'checks', idItem: 's04', correct: [{ idGroup: 'checks', idItem: 's04' }] },
      { idGroup: 'checks', idItem: 's05', correct: [{ idGroup: 'checks', idItem: 's05' }] },
      { idGroup: 'checks', idItem: 's06', correct: [{ idGroup: 'checks', idItem: 's06' }] },
    ],
  },
  layout: {
    groups: [
      {
        idGroup: 'checks',
        positions: { pos: { x: 0, y: -50 } },
        itemsConfig: {
          background: {
            text: { size: '40px', textAlign: 'center', textBaseline: 'middle', font: 'Myriad Pro' },
          },
        },
        otherProperty: {
          pair: {
            check: {
              positions: { pos: { width: 350, height: 300 } },
              background: { image: { src: dirPath + '/img/check.png' } },
            },
          },
        },
        items: [
          {
            id: 's00',
            background: {
              color: '#ffffff10',
            },
            positions: { type: 'absolute', pos: { width: 144, height: 80, x: 320, y: 720 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -40, x: 20 } } } } },
          },
          {
            id: 's01',
            background: {
              color: '#ffffff10',
            },
            positions: { type: 'absolute', pos: { width: 80, height: 80, x: 580, y: 585 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -30, x: 0 } } } } },
          },
          {
            id: 's02',
            background: {
              color: '#ffffff10',
            },
            positions: { type: 'absolute', pos: { width: 220, height: 100, x: 720, y: 720 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -30, x: 60 } } } } },
          },
          {
            id: 's03',
            background: {
              color: '#ffffff10',
            },
            positions: { type: 'absolute', pos: { width: 60, height: 100, x: 1080, y: 790 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -40, x: -10 } } } } },
          },
          {
            id: 's04',
            background: {
              color: '#ffffff10',
            },
            positions: { type: 'absolute', pos: { width: 100, height: 80, x: 1286, y: 600 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -30, x: 0 } } } } },
          },
          {
            id: 's05',
            background: {
              color: '#ffffff10',
            },
            positions: { type: 'absolute', pos: { width: 220, height: 80, x: 1280, y: 720 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -30, x: 60 } } } } },
          },
          {
            id: 's06',
            background: {
              color: '#ffffff10',
            },
            positions: { type: 'absolute', pos: { width: 80, height: 80, x: 1185, y: 695 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -40, x: -10 } } } } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  realHeight: 850,
  realWidth: 1800,
  mixinEngine: 'select',
  mainImage: {
    imagePath: dirPath + '/img/bcg.jpg',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
    height: 1080,
    cssStyle: {
      positions: 'absolute',
    },
  },
  configGame: configGame,
};

export default dataConfig;
